import { sendStructEvent } from '../../api';

interface PayloadProps {
    orderID?: string;
    userID?: number | string | null;
    productData: {
        id: number | string;
        name: string;
        coreAttribute: string;
        selectedPlan: number;
        totalCents: number;
        slug?: string;
    };
}

export const sendCartProductCardClick = (payload: PayloadProps): void => {
    const { orderID = null, userID = null, productData } = payload;
    sendStructEvent({
        eventCategory: 'cartProductCardClick',
        eventAction: 'cartProductCardClick',
        eventLabel: productData.name,
        eventProperty: {
            orderID,
            userID,
            productData,
        },
    });
};
